import { ChangeEventHandler, FocusEventHandler, useMemo } from 'react';

import './index.scss';

export interface WfTextareaProps {
  value: string;
  variation?: 'error';
  placeholder?: string;
  maxLength?: number;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
}

function WfTextarea(props: WfTextareaProps) {
  const { value, variation, placeholder, maxLength, onChange, onBlur } = props;

  const textareaClassName = useMemo(() => {
    const isError = variation === 'error';
    return `wf-textarea ${isError ? 'wf-textarea_error' : ''}`;
  }, [variation]);

  return (
    <textarea
      className={textareaClassName}
      value={value}
      placeholder={placeholder}
      maxLength={maxLength}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}

export default WfTextarea;
